<template>
  <HelperMessage>
    <v-icon small>mdi-help-circle-outline</v-icon>
    <template #message>
      <div
        v-for="(method, index) in methods"
        :key="index"
        class="d-flex flex-row align-center"
      >
        <strong class="mr-2">{{ method.type }}:</strong>
        <span>{{ method.description }} </span>
      </div>
    </template>
  </HelperMessage>
</template>
<script>
const METHODS = [
  { type: "Manual", description: "Se registro por un Asesor" },
  {
    type: "Automatico",
    description: "Se registro por medio de un sistema externo"
  },
  { type: "Conversion", description: "Se creo a partir de un Lead" },
  { type: "Indefinido", description: "No se ha definido un método de creación" }
];
export default {
  name: "HelpMsgMethodBrexCreation",
  components: {
    HelperMessage: () => import("../../common/HelperMessage.vue")
  },
  data() {
    return {
      methods: METHODS
    };
  }
};
</script>
